import e, { memo as w, useCallback as R } from "react";
import { useTheme as y, Flex as o, Image as B, Skeleton as I } from "@chakra-ui/react";
import { MdArrowBack as _ } from "@react-icons/all-files/md/MdArrowBack";
import { MdClose as x } from "@react-icons/all-files/md/MdClose";
import "react-icons/md";
import { Button as d } from "../../atoms/button/button.js";
import "../../atoms/button/icon-button.js";
import "react-icons/fa";
import "@loadable/component";
import "../../atoms/button/masthead-button.js";
import "@chakra-ui/system";
import "framer-motion";
import "react-icons/fi";
import "react-icons/hi";
import "react-icons/ri";
import "react-icons/io5";
import "../../atoms/button/close-button.js";
const D = w(
  ({
    clickHandler: r,
    logoUrl: m,
    onClose: c,
    logoAltText: u,
    currentLevel: s,
    ariaLabels: p
  }) => {
    const {
      logo: { smallHeight: g, smallWidth: k },
      action: a,
      menuDefaultIcon: n,
      background: { mid: l, default: t },
      menuMediumPadding: i,
      palette: { sdmRed: b },
      menu: { smallBorderRadius: C }
    } = y(), f = R(
      () => r(),
      [r]
    ), { CLOSE: h, BACK: E } = p;
    return /* @__PURE__ */ e.createElement(o, { justifyContent: "space-between", backgroundColor: b }, s > 0 ? /* @__PURE__ */ e.createElement(
      d,
      {
        leftIcon: /* @__PURE__ */ e.createElement(
          _,
          {
            color: a.primaryDefault,
            size: n
          }
        ),
        padding: i,
        variant: "transparent",
        onClick: f,
        "data-testid": "headline-back-link",
        "aria-label": E,
        backgroundColor: t,
        borderRadius: 0,
        _hover: { backgroundColor: l },
        _focus: { backgroundColor: t }
      }
    ) : /* @__PURE__ */ e.createElement(o, { backgroundColor: t, minW: "62px", width: "62px" }), /* @__PURE__ */ e.createElement(
      o,
      {
        width: "100%",
        backgroundColor: t,
        justifyContent: "center",
        alignItems: "center"
      },
      /* @__PURE__ */ e.createElement(
        B,
        {
          fallback: /* @__PURE__ */ e.createElement(I, { "data-testid": "skeleton-image", w: "100%", minH: "100%" }),
          "data-testid": "headline-logo",
          src: m,
          alt: u,
          loading: "lazy",
          width: k,
          height: g,
          tabIndex: -1,
          backgroundColor: t
        }
      )
    ), /* @__PURE__ */ e.createElement(
      d,
      {
        leftIcon: /* @__PURE__ */ e.createElement(x, { color: a.primaryDefault, size: n }),
        "aria-label": h,
        variant: "transparent",
        padding: i,
        "data-testid": "headline-close",
        onClick: c,
        backgroundColor: t,
        borderRadius: 0,
        borderTopRightRadius: C,
        _hover: { backgroundColor: l },
        _focus: { backgroundColor: t }
      }
    ));
  }
);
D.displayName = "DrawerMenuHeader";
export {
  D as DrawerMenuHeader
};
